export const GEOFENCE_SAMPLE_INTERVAL_MS = 60_000;
export const GEOFENCE_BREACH_GRACE_PERIOD_MS = 5 * 60_000;
export const GEOFENCE_WARNING_BUFFER_METERS = 25;
export const GEOFENCE_MAX_SIGNAL_ACCURACY_METERS = 150;

export type GeofenceAssessment = {
  withinRadius: boolean;
  outsideWarningRadius: boolean;
  outsideAutoCheckoutRadius: boolean;
  accuracyBufferMeters: number;
  weakSignal: boolean;
};

export const getGeofenceAccuracyBufferMeters = (accuracyM?: number | null) => {
  if (typeof accuracyM !== 'number' || !Number.isFinite(accuracyM) || accuracyM <= 0) {
    return GEOFENCE_WARNING_BUFFER_METERS;
  }

  return Math.max(GEOFENCE_WARNING_BUFFER_METERS, Math.min(Math.round(accuracyM), 100));
};

export const assessGeofencePosition = ({
  distanceM,
  radiusM,
  accuracyM,
}: {
  distanceM: number;
  radiusM: number;
  accuracyM?: number | null;
}): GeofenceAssessment => {
  const accuracyBufferMeters = getGeofenceAccuracyBufferMeters(accuracyM);
  const weakSignal =
    typeof accuracyM === 'number' &&
    Number.isFinite(accuracyM) &&
    accuracyM > GEOFENCE_MAX_SIGNAL_ACCURACY_METERS;

  return {
    withinRadius: distanceM <= radiusM,
    outsideWarningRadius: distanceM > radiusM,
    outsideAutoCheckoutRadius: !weakSignal && distanceM > radiusM + accuracyBufferMeters,
    accuracyBufferMeters,
    weakSignal,
  };
};

export const formatCountdownLabel = (remainingMs: number) => {
  const remainingSeconds = Math.max(Math.ceil(remainingMs / 1000), 0);
  const minutes = Math.floor(remainingSeconds / 60);
  const seconds = remainingSeconds % 60;

  if (minutes <= 0) {
    return `${seconds}s`;
  }

  return `${minutes}m ${String(seconds).padStart(2, '0')}s`;
};
